//https://transform.tools/css-to-js
export default (props: { isDarkMode: boolean }) => {
  const textColor = props.isDarkMode ? '#f5f5f9' : '#232121';
  const reportBlue = 'rgb(0, 173, 229)';

  return {
    ul: {
      paddingLeft: '10px',
      '> li': {
        textIndent: '-1.5em',
        paddingLeft: '1.5em',
        listStyleType: 'none',
        ['breakInside' as any]: 'avoid',
        '&:before': {
          content: "'\\2022'",
          marginRight: '5px',
          color: reportBlue
        },
        'strong + span:before': {
          content: "'\\2022'",
          marginRight: '5px',
          color: textColor,
          paddingLeft: '3px'
        },
        '> *': { textIndent: 'initial' }
      }
    }
  };
};
